import React from "react";
import { FaStar, FaQuoteLeft, FaArrowRight } from "react-icons/fa";
import "./Testimonials.css";

const Testimonials = () => {
  const metrics = [
    { value: "100+", label: "Active Remote Workers Managed" },
    { value: "40+", label: "Operational Sites Across Canada & UK" },
    { value: "12,000+", label: "Jewelry Items Reconciled in Minutes" },
    { value: "0", label: "Recurring Maintenance Cost" },
  ];

  // Featured (Hero) testimonial
  const featured = {
    name: "Ramesh Jegarajah",
    company: "Golden Food & Manufacture Ltd (Mr.Goudas)",
    companyLogo:
      "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2Fgoudas.png?alt=media&token=0c9c2b44-868e-46ba-9bb1-defe06f0e93e",
    companyWebsite: "https://goudas.ca",
    role: "President & CEO",
    image:
      "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2FRamesh.jpg?alt=media&token=45743de2-79db-4cdc-8d4a-c728987d500a",
    rating: 5,
    text:
      "Instant Digits didn’t just build software — they engineered our digital ecosystem. " +
      "From Sales Management to Manufacturing workflows, Receivables control, and now our ERP, everything works seamlessly at scale. " +
      "Their ability to simplify complex operations into powerful, easy-to-use systems is exceptional. " +
      "Highly recommended as a long-term technology partner.",
  };

  // Secondary grid testimonials (short, scannable, high impact)
  const clients = [
    {
      name: "Kris Sivaguru",
      company: "Shinol Inc.",
      companyLogo:
        "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2FShinol.png?alt=media&token=3e1e6355-addd-427f-9d06-bd7464f782f3",
      companyWebsite: "https://www.shinol.ca",
      role: "President",
      image:
        "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2FKrish.jpg?alt=media&token=9b6d8576-9adf-4c19-8f77-4ecfe5cc54b1",
      rating: 5,
      text:
        "Zero maintenance costs — and they built our exclusive platform to manage 100+ remote workers across 15+ sites in Canada with real-time capabilities. " +
        "Performance across all devices stands out. Highly cost-effective and fully customized.",
    },
    {
      name: "Atif Majeed",
      company: "Super Asia Foods",
      companyLogo:
        "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2FSuper%20Asia%20Foods.png?alt=media&token=9eec1156-bfbb-41c6-b88f-6e99b2e263f3",
      companyWebsite: "https://superasia.ca",
      role: "CEO/COO",
      image:
        "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2FAtif.jpg?alt=media&token=8198120c-e8d3-4339-92f2-00104190d19c",
      rating: 5,
      text:
        "They understood our unique workflows and built every module exactly for how we operate. " +
        "A fully customized IntelliSales — promotions, automation, and smooth synchronization with accounting software.",
    },
    {
      name: "Ranganathan Pathmanathan",
      company: "New Ranganas Jewellery",
      companyLogo:
        "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2FLogoRangan.png?alt=media&token=18c4dfbc-a3f6-4a76-8db6-7ab26bf72e47",
      companyWebsite: "https://www.instagram.com/new_ranganas",
      role: "President & Owner",
      image:
        "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2FRangan.jpg?alt=media&token=ab4b4c2d-738a-4c80-87ef-a0226528514d",
      rating: 5,
      text:
        "RFID-driven stock management transformed our retail operations. Reconciling 12,000+ jewelry items now takes 5 minutes instead of nearly 3 hours. " +
        "Highly recommended for industry-specific, customized solutions.",
    },
    {
      name: "Mr. Suthan",
      company: "Saghana Jewellers (UK)",
      companyLogo:
        "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2FSaghanaJewelLogo.jpg?alt=media&token=2cab9596-434e-40e9-8670-281b80670039",
      companyWebsite: "https://www.facebook.com/saghanajewellers/",
      role: "Director",
      image:
        "https://firebasestorage.googleapis.com/v0/b/shoppy-lens.appspot.com/o/Website%2Ftestimonials%2FSaghanaJewelLogo.jpg?alt=media&token=2cab9596-434e-40e9-8670-281b80670039",
      rating: 5,
      text:
        "As the first IntelliGold customers in the UK, we were impressed by how comprehensively the platform covers a jewelry retail business — from stock security to orders and tracking. " +
        "Outstanding visibility and control in one system.",
    },
  ];

  const renderStars = (count) => (
    <div className="t-stars" aria-label={`${count} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <FaStar key={i} className={`t-star ${i < count ? "filled" : ""}`} />
      ))}
    </div>
  );

  return (
    <section className="t-section" id="testimonials">
      <div className="t-container">
        {/* Header */}
        <div className="t-header">
          <div className="t-eyebrow">CLIENT PROOF</div>
          <h2 className="t-title">Trusted by Growing & Enterprise Businesses</h2>
          <p className="t-subtitle">
            From Food industry to Property management, logistics, jewelry and retail — we build
            systems that power real operations at scale.
          </p>
        </div>

        {/* Metrics */}
        <div className="t-metrics" role="list">
          {metrics.map((m) => (
            <div key={m.label} className="t-metric" role="listitem">
              <div className="t-metricValue">{m.value}</div>
              <div className="t-metricLabel">{m.label}</div>
            </div>
          ))}
        </div>

        {/* Featured testimonial */}
        <div className="t-featured">
          <div className="t-featuredLeft">
            <div className="t-quoteIcon" aria-hidden="true">
              <FaQuoteLeft />
            </div>

            {renderStars(featured.rating)}

            <p className="t-quote">“{featured.text}”</p>

            <div className="t-personRow">
              <img src={featured.image} alt={featured.name} className="t-avatar" loading="lazy" />
              <div className="t-personInfo">
                <div className="t-personName">{featured.name}</div>
                <div className="t-personRole">{featured.role}</div>
                <div className="t-personCompany">{featured.company}</div>
              </div>
            </div>
          </div>

          <div className="t-featuredRight">
            <a
              href={featured.companyWebsite}
              target="_blank"
              rel="noopener noreferrer"
              className="t-clientLink"
              aria-label={`Visit ${featured.company} website`}
            >
              <div className="t-clientCard">
                <img
                  src={featured.companyLogo}
                  alt={`${featured.company} logo`}
                  className="t-clientLogo"
                  loading="lazy"
                />
                <div className="t-clientCta">
                  <span>Visit Client Site</span>
                  <FaArrowRight />
                </div>
              </div>
            </a>

            <div className="t-featuredHint">Built for real-world operations — not demos.</div>
          </div>
        </div>

        {/* Client grid */}
        <div className="t-grid">
          {clients.map((c) => (
            <article key={`${c.name}-${c.company}`} className="t-card">
              <div className="t-cardTop">
                {renderStars(c.rating)}
                <a
                  href={c.companyWebsite}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="t-miniClient"
                  aria-label={`Open ${c.company} website`}
                >
                  <img
                    src={c.companyLogo}
                    alt={`${c.company} logo`}
                    className="t-miniLogo"
                    loading="lazy"
                  />
                </a>
              </div>

              <p className="t-cardQuote">“{c.text}”</p>

              <div className="t-cardFooter">
                <img src={c.image} alt={c.name} className="t-miniAvatar" loading="lazy" />
                <div className="t-cardPerson">
                  <div className="t-cardName">{c.name}</div>
                  <div className="t-cardRole">{c.role}</div>
                  <div className="t-cardCompany">{c.company}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Bottom note */}
        <div className="t-bottomNote">
          Want similar results? Let’s build a solution that matches your exact workflow.
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
